<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>帐号管理</el-breadcrumb-item>
        <el-breadcrumb-item>人员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addDialog" >添加人员</el-button></span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            prop="username"
            width="220"
            label="用户名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="role_name"
            label="职能">
          </el-table-column>
          <el-table-column
            align="center"
            prop="account"
            label="帐号">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="320">
            <template slot-scope="scope" >
              <el-button
                v-show="scope.row.role_id !== 1000"
                type="primary"
                size="small"
                @click="editDialog(scope.row.id)">编辑
              </el-button>
              <el-popconfirm
                v-show="scope.row.role_id !== 1000"
                confirmButtonText='确认'
                cancelButtonText='取消'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogAddVisible" :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="addForm" label-width="120px" :rules="storeRules" ref="addForm">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addForm.username" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="职能" prop="role_id">
          <el-select v-model="addForm.role_id"  placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.role_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="帐号" prop="account">
          <el-input v-model="addForm.account" auto-complete="off" placeholder="请输入帐号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input placeholder="请输入密码" v-model="addForm.password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="add('addForm')">确 定</el-button>
        <el-button @click="callOf('addForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogEditVisible" :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="editForm" label-width="120px" :rules="editRules" ref="editForm">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="editForm.username" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="职能" prop="role_id">
          <el-select v-model="editForm.role_id"  placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.role_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="帐号" prop="account">
          <el-input v-model="editForm.account" auto-complete="off" disabled placeholder="请输入帐号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input placeholder="可空，输入密码即重置密码" v-model="editForm.password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="edit('editForm')">确 定</el-button>
        <el-button @click="callOf('editForm')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" >
  .el-transfer__button{
    display: block!important;
    width: 100%;
  }
  .el-button+.el-button{
    margin: 0;
  }
  .el-checkbox{
    margin: 0;
    text-align: left;
  }
  .el-transfer-panel__item{
    width: 100%;
    max-width: 200px;
  }
  .el-transfer-panel__list{
    overflow-x:hidden;
  }
</style>

<script>
import {addUser, delUser, editUser, userRoles, userInfo, userList} from '../../api/auth'

export default {
  data () {
    return {
      dialogAddVisible: false,
      dialogEditVisible: false,
      dialogTitle: '',
      tableData: [],
      page: 1,
      page_size: 50,
      total: 0,
      roleList: [],
      addForm: {
        username: '',
        account: '',
        role_id: '',
        password: ''
      },
      editForm: {
        id: 0,
        username: '',
        account: '',
        role_id: '',
        password: ''
      },
      storeRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '请输入帐号', trigger: 'blur' }
        ],
        role_id: [
          { required: true, message: '请选择职能', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      editRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '请输入帐号', trigger: 'blur' }
        ],
        role_id: [
          { required: true, message: '请选择职能', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.setTableData()
    this.getRoleList()
  },
  methods: {
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 表格渲染
    setTableData () {
      userList({
        page: this.page,
        page_size: this.page_size
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.total = res.data.total
          this.tableData = res.data.table_list
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 添加弹窗
    addDialog () {
      this.dialogTitle = '添加职能'
      this.dialogAddVisible = true
    },
    // 关闭弹窗
    callOf (formName) {
      if (formName === 'addForm') {
        this.dialogAddVisible = false
      } else if (formName === 'editForm') {
        this.dialogEditVisible = false
      }
      if (formName) {
        this.fileList = []
        this.file = {}
        this.$refs[formName].resetFields()
      }
    },
    // 获取所有角色
    getRoleList () {
      userRoles().then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.roleList = res.data
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 添加职能
    add (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addUser(this.addForm).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.dialogAddVisible = false
              this.setTableData()
              this.$refs[formName].resetFields()
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
    },
    // 编辑弹窗
    editDialog (id) {
      this.dialogEditVisible = true
      this.dialogTitle = '编辑职能'
      userInfo({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.editForm = res.data
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 编辑提交
    edit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editUser(this.editForm).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.dialogEditVisible = false
              this.setTableData()
              this.$refs[formName].resetFields()
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
    },
    // 删除职能
    del (id) {
      delUser({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.setTableData()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/personnel/index.vue